module.exports = __webpack_public_path__ + "static/media/game_bottom_background@768.b0da4d9a.png";